<div class="input-area-container" [ngClass]="containerCss">
  <div [ngClass]="contentCss">
    <label [ngClass]="[labelCss, labelRequired ? 'label-required' : '']" *ngIf="label">{{ label }}</label>
    <div class="display-flex flex-column fill">
      <div class="input-wrapper">
        <div
          *ngIf="useEmoji"
          class="emoji-button"
          (mousedown)="storeSelection()"
          (mouseenter)="emojiActive = true"
          (mouseleave)="emojiActive = false"
          [matMenuTriggerFor]="emojiMenu"
        >
          <mat-icon *ngIf="!emojiActive" [svgIcon]="'emojiDefault'"></mat-icon>
          <mat-icon *ngIf="emojiActive" [svgIcon]="'emojiHover'"></mat-icon>
        </div>
        <mat-menu #emojiMenu="matMenu" class="menu-with-backdrop filter-menu emoji-menu">
          <div (click)="stopPropagation($event)">
            <emoji-mart
              [color]="'#4eb08d'"
              [set]="''"
              [style]="{ border: '0' }"
              [isNative]="true"
              [sheetSize]="20"
              (emojiClick)="addEmoji($event)"
            ></emoji-mart>
          </div>
        </mat-menu>
        <div *ngIf="useEmoji" class="emoji-separator"></div>
        <div
          #editInput
          contenteditable="true"
          appCustomTooltip
          [showToolTip]="displayNewLineHint"
          [contentTemplate]="textAreaTooltipTemplate"
          (mousedown)="$event.stopPropagation()"
          (keydown.enter)="enter($event)"
          (keydown.space)="space($event)"
          (keydown.meta.enter)="insertBr()"
          (keydown.control.enter)="insertBr()"
          class="editable-container"
          [attr.placeholder]="attrPlaceholder"
          [ngClass]="[
            inputCss,
            (invalid && showValidationError) || markAsInvalid || (maxCounter > 0 && getValueLength() > maxCounter)
              ? 'invalid'
              : '',
            errors ? 'error-section' : '',
            control.value ? 'filled' : '',
            sendButton ? 'with-send' : '',
            useEmoji ? 'with-emoji' : ''
          ]"
          [ngStyle]="{ 'max-height': maxHeight + 'px' }"
          [formControl]="control"
          [attr.aria-invalid]="invalid && showValidationError"
          (blur)="onBlur()"
          [mentionConfig]="mentionConfig"
          (itemSelected)="mentionItemSelected($event)"
        ></div>
        <div class="send-button" [ngClass]="{ active: control.valid }" *ngIf="sendButton" (click)="send()">
          <mat-icon>send</mat-icon>
        </div>
      </div>
      <div class="display-flex justify-content-space-between">
        <div
          *ngIf="displayCounter"
          class="placeholder counter"
          [ngClass]="getValueLength() > maxCounter ? 'text-color red3' : ''"
        >
          [{{ getValueLength() }}/{{ maxCounter }}]
        </div>
      </div>
      <app-input-error
        *ngIf="errorSection && errors"
        [errors]="errors"
        [visible]="markAsInvalid || (errors && showValidationError)"
      ></app-input-error>
    </div>
  </div>
</div>

<ng-template #textAreaTooltipTemplate>
  <div class="custom-text-area-tooltip-content">
    <div class="body-small text-color gray11">ctr/cmd + enter: new line</div>
  </div>
</ng-template>
